<script setup>
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/SharedUI/Footer.vue';
</script>
<template>
    <Navbar />
    <v-container class="my-10">
        <v-card elevation="3" class="pa-6">
            <v-card-title class="text-h5 font-weight-bold mb-4">Privacy Policy</v-card-title>
            <v-card-text>
                <p><strong>General</strong><br />
                    At MeroPrints, we value your privacy and are committed to protecting your personal information. This
                    Privacy Policy outlines how we collect, use, and protect information related to our ID card printing
                    and associated services (including RFID integration). By using our website or services, you agree to
                    the terms outlined below.</p>

                <h3>1. Collection of Personal Information</h3>
                <p>We collect personal information for printing and processing ID cards, including RFID-enabled cards,
                    and for communication purposes.</p>
                <ul>
                    <li>Name, photo, school or organization details</li>
                    <li>Student, teacher, or staff information (for ID generation)</li>
                    <li>Contact information such as phone or email</li>
                    <li>Delivery address (if applicable)</li>
                </ul>

                <h3>2. Use of Personal Information</h3>
                <p>Your data is used to fulfill your order and improve our services. We do not sell or rent your
                    personal information.</p>
                <ul>
                    <li>Generate customized ID cards</li>
                    <li>Contact you about order status or updates</li>
                    <li>Improve service quality and user experience</li>
                    <li>Fulfill legal and security obligations</li>
                </ul>

                <h3>3. Disclosure of Personal Information</h3>
                <p>We may share your data with trusted third parties only when necessary:</p>
                <ul>
                    <li>Delivery services (for shipping orders)</li>
                    <li>Technical support providers</li>
                    <li>Legal authorities when required by law</li>
                </ul>

                <h3>4. Data Security</h3>
                <p>We implement industry-standard security practices to safeguard your personal data. However, no system
                    is entirely immune to breaches.</p>

                <h3>5. Data Retention</h3>
                <p>We retain your data only as long as needed to complete your service or comply with legal
                    requirements.</p>

                <h3>6. RFID and Sensitive Data</h3>
                <p>RFID-enabled ID cards may store non-sensitive identification data. We do not embed or store sensitive
                    biometric or financial information on the RFID chips.</p>

                <h3>7. Children's Data</h3>
                <p>We process children's data only with authorization from schools or parents/guardians for ID card
                    creation. We do not use it for marketing.</p>

                <h3>8. Permissions and Device Access</h3>
                <p>When using our app, we may request access to your camera, storage, or location for photo uploads or
                    delivery services. These permissions are optional and controlled by you.</p>

                <h3>9. Changes to This Policy</h3>
                <p>We may update this policy as needed. All changes will be posted on our website with the effective
                    date.</p>

                <h3>Contact Us</h3>
                <p>If you have any questions or concerns, feel free to contact us at <a
                        href="mailto:contact@brosoftltd.com">contact@brosoftltd.com</a>.</p>
            </v-card-text>

        </v-card>
    </v-container>
    <Footer />
</template>

<style scoped>
p {
    line-height: 1.8;
    font-size: 16px;
    color: #424242;
    margin-bottom: 1rem;
}

ul {
    padding-left: 1.5rem;
    margin-bottom: 1rem;
    list-style-type: disc;
}

h3 {
    margin-top: 2rem;
    margin-bottom: 0.5rem;
    font-weight: 600;
    font-size: 18px;
}

a {
    color: #1e88e5;
    text-decoration: underline;
}

a:hover {
    color: #1565c0;
    text-decoration: none;
}
</style>
